/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatAxis {
    getFixupPrototypeFunction() { return AgentChatAxis.fixupPrototype; }

    static newInstance(model: Partial<AgentChatAxis>): AgentChatAxis {
        let obj = Object.assign(new AgentChatAxis(), model);
        AgentChatAxis.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatAxis>): AgentChatAxis {
        if (!model) return null;
        return AgentChatAxis.newInstance(<AgentChatAxis> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatAxis) {
        if (!obj) return;

        models.AgentChatAxis.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatAxis): boolean {
        Object.setPrototypeOf(obj, AgentChatAxis.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Identifier of the axis value.
     */
    identifier: string;

    /**
     * Label of the axis.
     */
    label: string;

}
